import { useState } from 'react';
import { DataGrid, GridRowsProp, GridColDef, GridCellParams } from '@mui/x-data-grid';
import { defaultLocation, Location, Company } from '../../models/location.interface';
import { Grid, IconButton } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { EditLocationDialog } from './EditLocationDialog';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    dataGridRoot:{
      border: 0,
      '& .header' : {
        background: theme.palette.background.default,
        color: theme.palette.primary.dark,
        fontWeight: '600', 
        fontSize: 16,
        padding: theme.spacing(0),
      },
      '& .MuiDataGrid-menuIconButton': {
        color: theme.palette.primary.dark,
        size: 'small',
        padding: theme.spacing(0),
      },
      '& .MuiDataGrid-sortIcon': {
        color: theme.palette.primary.dark,
        size: 'small',
        padding: theme.spacing(0),
      },
      headerHeight: 45,
      rowHeight: 40,
      pageSize: 10,
    },
    margin: {
      margin: theme.spacing(1),
    },
  }),
);

interface ILocationsGridProps {
  locationList: Location[]
  loadAllLocations: () => void
  companyList: Company[]
}

export const LocationsGrid = ({
  locationList, loadAllLocations, companyList
}: ILocationsGridProps) => {
  const classes = useStyles();
  const [ edit, setEdit ] = useState<boolean>(false);
  const [ editLocation, setEditLocation ] = useState<Location>({...defaultLocation});

  const columns: GridColDef[] = [
    { 
      field: 'name', 
      headerClassName: 'header', 
      headerAlign: 'center',
      headerName: 'Name', 
      flex: 2
    },
    { 
      field: 'companyName', 
      headerClassName: 'header', 
      headerAlign: 'center',
      headerName: 'Company', 
      flex: 1
    },
    { 
      field: 'phoneNumber', 
      headerClassName: 'header', 
      headerAlign: 'center',
      headerName: 'Phone Number', 
      flex: 1
    },
    { 
      field: 'editId', 
      headerClassName: 'header', 
      headerAlign: 'center',
      headerName: 'Edit', 
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <Grid container 
            justifyContent="center" 
            alignItems="center" 
            style={{ minHeight: '10vh' }}
          >
          <IconButton
            aria-label="delete"
            className={classes.margin}
            onClick={() => showEditDialog(params)}
            color="primary"
          >
              <EditOutlinedIcon fontSize="medium" />
            </IconButton>
        </Grid>
      ),
    }
  ];

  const showEditDialog = (params: GridCellParams) => {
    setEdit(true)
    const loc: Location = {
      id: params.row.id, 
      name: params.row.name,
      phoneNumber: params.row.phoneNumber, 
      company: params.row.company
    }
    
    setEditLocation(loc);
  }

  const handleEditClose = () => {
    setEdit(false);
    loadAllLocations();
  };

  const rows: GridRowsProp = locationList.map((loc, index) => ({ 
    id: loc.id,
    name: loc.name,
    companyName: loc.company.name,
    company: loc.company,
    phoneNumber: loc.phoneNumber,
    editId: loc.id,
  }));

  return (
    <>
      <div style={{ height: 500, width: '100%' }} className={classes.dataGridRoot}>
        <DataGrid 
          rows={rows} 
          columns={columns} 
          pageSize={10} 
          rowHeight={40} 
          headerHeight={45}
          rowsPerPageOptions={[10]}
        />
      </div>
      <EditLocationDialog
        open= {edit}
        onClose={handleEditClose} 
        location={editLocation}
        loadAllLocations={loadAllLocations}
        companyList={companyList}
      /> 
    </>
  );
};

export default LocationsGrid;
